import { createContext, useContext, type ReactNode } from 'react';
import type { ChatReference } from '../interfaces/host';

export type ReferenceHandler = (reference: ChatReference) => void;

const ReferenceActionContext = createContext<ReferenceHandler | null>(null);

/**
 * Provides the handler invoked when a user clicks an actionable reference (deep
 * link) inside an assistant message. Lets the deeply-nested Markdown renderer
 * trigger a host navigate message without prop-drilling.
 */
export function ReferenceActionProvider({
  onReference,
  children,
}: {
  onReference: ReferenceHandler;
  children: ReactNode;
}) {
  return (
    <ReferenceActionContext.Provider value={onReference}>{children}</ReferenceActionContext.Provider>
  );
}

export function useReferenceAction(): ReferenceHandler | null {
  return useContext(ReferenceActionContext);
}
